export const getAbsoluteUrl = (href, sitecoreContext) => {
  const domain = sitecoreContext?.siteSettings?.TargetHostName?.value;
  const currentLang = sitecoreContext?.route.itemLanguage;

  if (!href || href.startsWith('http') || href.startsWith('mailto:') || href.startsWith('tel:')) {
    return href;
  }

  if (!domain) return href;

  let path = href.startsWith('/') ? href : `/${href}`;

  const locales = ['en', 'ar', 'fr', 'zh', 'it', 'ja', 'tr', 'ru', 'pt'];

  const hasLocale = locales.some(locale => path.startsWith(`/${locale}/`) || path === `/${locale}`);
  if (!hasLocale) {
    path = `/${currentLang}${path === '/' ? '' : path}`;
  }

  return `https://${domain}${path}`;
};
